import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col font-montserrat overflow-hidden pt-4 h-full" }
const _hoisted_2 = { class: "flex flex-row text-20px py-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "w-full border-b border-gray-lp-400" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createBlock("button", {
          key: tab.name,
          onClick: ($event: any) => (_ctx.changeTabs(tab.name)),
          class: 
          ` w-48 font-semibold hover:text-red-lp-100 focus:outline-none ${
            _ctx.currentTab === tab.name
              ? 'text-red-lp-100 border-b-2 border-red-lp-100'
              : 'text-gray-lp-600 border-b border-gray-lp-400'
          }`
        
        }, _toDisplayString(tab.title), 11, ["onClick"]))
      }), 128)),
      _hoisted_3
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTab)))
  ]))
}